<template>
  <p class="countdown-display" :class="`countdown-display--${categoryColor}`">{{ countDown }}</p>
</template>

<script>
import {COUNTDOWN_DURATION_SECS} from './../constants/globalConstants';

export default {
  name: 'CountdownDisplay',
  components: {},
  props: {
    categoryColor: {
      type: String,
      default: '',
    },
    countDown: {
      type: Number,
      default: COUNTDOWN_DURATION_SECS,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.countdown-display {
  font-size: 20rem;
  font-weight: 700;
  left: 50%;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  text-shadow: 0px 0px 20px hsla(0, 0%, 0%, 0.9);
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @include breakpoint($mq-sm) {
    font-size: 20rem;
  }

  @include breakpoint($mq-sm-md) {
    font-size: 23rem;
  }

  @include breakpoint($mq-md) {
    font-size: 26rem;
  }

  @include breakpoint($mq-md-lg) {
    font-size: 29rem;
  }

  @include breakpoint($mq-lg) {
    font-size: 32rem;
  }

  &--yellow {
    color: var(--color-yellow);
  }

  &--orange {
    color: var(--color-orange);
  }

  &--pink {
    color: var(--color-pink);
  }

  &--violet {
    color: var(--color-violet);
  }

  &--blue {
    color: var(--color-blue);
  }

  &--green {
    color: var(--color-green);
  }

  &--teal {
    color: var(--color-teal);
  }

  &--brown {
    color: var(--color-brown);
  }
}
</style>
